export default __webpack_public_path__ + "static/media/referenzen_intro_web-lg@1x.08d2dd67.webp";